import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const FundingAmountSchema = z.object({
  fundingAmountValue: z.number(),
})

type FundingAmountProps = z.infer<typeof FundingAmountSchema>

export class FundingAmount extends ValueObject<FundingAmountProps> {
  public toNumber(): number {
    return this.props.fundingAmountValue
  }

  public static create(props: FundingAmountProps): FundingAmount {
    const validatedProps = FundingAmountSchema.parse(props)
    return new FundingAmount(validatedProps)
  }
}
